// Updated (In progress Moving component) (Version-2, Upr wala code, i.e; of version-1 yet to work on)
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Box,
  Typography,
  Grid,
  Divider,
  Paper,
  TextField,
} from "@material-ui/core";
import BusinessInfoTabPage from "./BusinessInfoTabPage";
import GroupKnowledgeSessionTabPage from "./GroupKnowledgeSessionTabPage";
import ExpertConsultationTabPage from "./ExpertConsultationTabPage";
import MarketOpportunitiesTabPage from "./MarketOpportunitiesTabPage";
import CompliancesTabPage from "./CompliancesTabPage";
import LoanReadinessTabPage from "./LoanReadinessTabPage";
import { Button } from "../../common/Button/Button";
import PersonaDetailMarketConnectTabPage from "./PersonaDetailMarketConnectTabPage";
import PersonaDetailGroupKnowledgeSessionTabPage from "./PersonaDetailGroupKnowledgeSessionTabPage";
import PersonaDetailExpertConsultationTabPage from "./PersonaDetailExpertConsultationTabPage";
import PersonaDetailComplianceTabPage from "./PersonaDetailComplianceTabPage";
import PersonaDetailBusinessLoanReadinessTabPage from "./PersonaDetailBusinessLoanReadinessTabPage";
import api from "../../utils/api";
import DigitalEnablementTab from "./DigitalEnablementTab";
import PersonaDetailDigitalEnablementTab from "./PersonaDetailsDigitalTab";



function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other} style={{ height: "100%", overflowY: "auto" }}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

// For New Tabs Rendered on "Hello" Click
const StaticTabPanel = ({ value, index, title }) => (
  <div role="tabpanel" hidden={value !== index} style={{ height: "100%", overflowY: "auto" }}>
    {value === index && (
      <Box p={2}>
        <Typography variant="h6" style={{ color: "#75287c" }}>
          {title}
        </Typography>
      </Box>
    )}
  </div>
);

const JpmcThreeSixtyDegreeModalProfilePage = ({ open, onClose, userData, userDetail, userResourcesCount, resourcesDetails, userGroupKnowledgeSesssionPersonaDetails, userExptConsultationPersonaDetails, userCompliancePersonalDetails, userMarketConnectPersonaDetails, userLoanReadinessPersonaDetails, userDigitalEanblementPersonaDetails, handleSubmitPersonaDetails, handleSubmitDigitalPersonaDetails, isPersonaLoading, addResourcesDetails, isPersonaFormOpen, setIsPersonaFormOpen, selectedResourceInstanceId, showNewSection, handleSetShowNewSection, tab, handleTabChange, newTab, handleNewTabChange, handleFormCancel, userPersonaDetailFile, setIsFormOpen, isFormOpen, uniqueGroupKnowledgeInstanceId, uniqueExpertConsultInstanceId, uniqueMarketOppInstanceId, uniqueComplianceInstanceId, uniqueLoandReadinessInstanceId, uniqueDigitalEnablementInstanceId,digitalEnablementInstances, handleUpdatePersonaDetail, 
  groupKnowledgeAlreadyFilledPersonaInstanceId ,
  expertConsiltAlreadyFilledPersonaInstanceId,
  marketConnectAlreadyFilledPersonaInstanceId,
  complianceAlreadyFilledPersonaInstanceId,
  loanReadinessAlreadyFilledPersonaInstanceId,
  digitalEnablementAlreadyFilledPersonaInstanceId
}) => {
  const [editedData, setEditedData] = useState({ ...userData });
  const [editableSections, setEditableSections] = useState({
    basic: false,
    business: false,
  });
  const toggleSectionEditable = (sectionKey) => {
    setEditableSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  const handleChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const userInfoItems = [
    { label: "Entry ID", field: "nEntryId" },
    { label: "Date of Joining", field: "dtCreated" },
    { label: "First Name", field: "sFirstName" },
    { label: "Last Name", field: "sLastName" },
    { label: "Mobile", field: "sMobile" },
    { label: "Age", field: "age" },
  ];

  const businessInfoItems = [
    { label: "Business Name", field: "sBusinessName" },
    { label: "Business Sector", field: "sBusinessSector" },
    { label: "Business Started Year", field: "sBusinessStartedYear" },
    { label: "Business Turnover", field: "sBusinessTurnover" },
    { label: "Business Pincode", field: "sBusinessPincode" },
    { label: "Family Income", field: "sFamilyIncome" },
  ];

  function extractDate(datetimeString) {
    // const date = new Date(datetimeString);
    // return date.toISOString().split('T')[0];
    return datetimeString
  }

  console.log(userMarketConnectPersonaDetails, ">>>>>userMarketConnectPersonaDetails in jpmc three sixty modal profile");
  console.log(newTab, ">>>>new tab");
  console.log(isPersonaFormOpen, ">>>>is persona form open");
  console.log(showNewSection, ">>>");
  console.log(editedData, ">>>>editedData");
  console.log(userPersonaDetailFile, ">>>>>userPersonaDetailFile");
  console.log(userResourcesCount, ">>>> userResourcesCount in prfile page");
  console.log(userData, ">>>>>userData in profile page");
  console.log(userDetail, ">>>>userDetail in profile page");
    let personaIndex = 0;
  return (
    <Box
      style={{
        minHeight: "80vh",
        backgroundColor: "#f9f6fb",
        // backgroundColor: "#000",
        borderRadius: "10px",
        padding: "24px",
      }}
    >
      {/* <Box
        style={{
          backgroundColor: "#75287c",
          color: "#fff",
          borderRadius: "12px 12px 0 0",
          padding: "16px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">User Details</Typography>
        <IconButton onClick={onClose} style={{ color: "#fff" }}>
          X
        </IconButton>
      </Box> */}

      {/* ─── Content ─── */}
      <Grid container spacing={3} style={{ marginTop: 0, height: "calc(100% - 64px)" }}>
        {/* Top Section */}
        {/* <Grid item xs={12}>
          <Paper
            elevation={2}
            style={{
              padding: "20px",
              borderRadius: "10px",
              border: "1px solid #d1b3d4",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {renderInfoSection("User Basic Information", "basic", userInfoItems)}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInfoSection("User Business Information", "business", businessInfoItems)}
              </Grid>
            </Grid>
          </Paper>
        </Grid> */}

        {/* Bottom Section */}
        <Grid item xs={12} style={{ backgroundColor: "", height: "650px", borderRadius: "10px", border: "1px solid #d1b3d4", }}>
          <Box style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            {/* <Button onClick={handleSetShowNewSection}>
              {showNewSection ?  "Persona Details" : "Resources Details"}
            </Button> */}

            {/* <Button onClick={()=>setIsFormOpen(!isFormOpen)}>
              {isFormOpen ?  "Persona Details" : "Persona Forms"}
            </Button> */}

            {/* {
              userPersonaDetailFile ? (
                <Button style={{ marginLeft: "20px" }}>
                  <a href={`${userPersonaDetailFile ? userPersonaDetailFile : ""}`} style={{ color: "#fff", textDecoration: "none" }}>
                    {"Download User Detail"}
                  </a>
                </Button>

              ) : (
                <Button disabled={!userPersonaDetailFile ? true : false} style={{ marginLeft: "20px" }}>
                  {"Download User Detail"}
                </Button>
              )
            } */}

          </Box>

          <Paper
            elevation={2}
            style={{
              //   padding: 0,
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              border: "1px solid #d1b3d4",
              height: "90%",
              overflow: "hidden",
              backgroundColor: "",
              padding: "20px"
            }}
          >
            <Box
              style={{
                backgroundColor: "#f1e6f4",
                borderBottom: "1px solid #d1b3d4",
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <Tabs
                value={showNewSection ?  tab : newTab }
                onChange={showNewSection ?  handleTabChange : handleNewTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#75287c",
                  },
                }}
              >
                {showNewSection ? <Tab label="User Resource Details" /> : ""}
                {/* <Tab label="Group Knowledge Session" />
                <Tab label="Expert Consultation" />
                <Tab label="Market Opportunities" />
                <Tab label="Compliances" />
                <Tab label="Loan Readiness" />
                <Tab label="Digital Enablement" /> */}
                {resourcesDetails?.KnowledgeSessions?.length > 0 && (
                  <Tab label="Group Knowledge Session" />
                )}

                {resourcesDetails?.ExpertConsultations?.length > 0 && (
                  <Tab label="Expert Consultation" />
                )}

                {resourcesDetails?.MarketOpportunities?.length > 0 && (
                  <Tab label="Market Opportunities" />
                )}

                {resourcesDetails?.Compliances?.length > 0 && (
                  <Tab label="Compliances" />
                )}

                {resourcesDetails?.LoanReadiness?.length > 0 && (
                  <Tab label="Loan Readiness" />
                )}
                {resourcesDetails?.Deigital?.length > 0 && (
                  <Tab label="Digital Enablement" />
                )}
              </Tabs>
            </Box>

            <Box style={{ flexGrow: 1, overflowY: "auto", backgroundColor: "" }}>
              {/* OLD WITH Resources Details */}
              {/* {showNewSection ? (
                <>
                  <PersonaDetailGroupKnowledgeSessionTabPage
                    value={newTab}
                    index={0}
                    title="Group Knowledge Session Details"
                    userGroupKnowledgeSesssionPersonaDetails={userGroupKnowledgeSesssionPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                  />
                  <PersonaDetailExpertConsultationTabPage
                    value={newTab}
                    index={1}
                    title="Expert Consultation Details"
                    userExptConsultationPersonaDetails={userExptConsultationPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                  />
                  <PersonaDetailMarketConnectTabPage
                    value={newTab}
                    index={2}
                    title="Market Opportunities Details"
                    userMarketConnectPersonaDetails={userMarketConnectPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                  />
                  <PersonaDetailComplianceTabPage
                    value={newTab}
                    index={3}
                    title="Compliances Details"
                    userCompliancePersonalDetails={userCompliancePersonalDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                  />
                  <PersonaDetailBusinessLoanReadinessTabPage
                    value={newTab}
                    index={4}
                    title="Loan Readiness Details"
                    userLoanReadinessPersonaDetails={userLoanReadinessPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                  />
                </>
              ) : (
                <>
                  <TabPanel value={tab} index={0}>
                    <BusinessInfoTabPage userData={userData} userResourcesCount={userResourcesCount} handleTabChange={handleTabChange} />
                  </TabPanel>
                  <TabPanel value={tab} index={1}>
                    <GroupKnowledgeSessionTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                  <TabPanel value={tab} index={2}>
                    <ExpertConsultationTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                  <TabPanel value={tab} index={3}>
                    <MarketOpportunitiesTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                  <TabPanel value={tab} index={4}>
                    <CompliancesTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                  <TabPanel value={tab} index={5}>
                    <LoanReadinessTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                </>
              )} */}


              {/* NEW WITHOUT CATEGORY DETAILS */}
              {/* showNewSection ? "Show Resources Details" : "Show Persona details" */}
              {showNewSection ? (
                <>
                  <TabPanel value={tab} index={0}>
                    <BusinessInfoTabPage userData={userData} userResourcesCount={userResourcesCount} handleTabChange={handleTabChange} />
                  </TabPanel>
                  {resourcesDetails?.KnowledgeSessions?.length > 0 && (
                  <TabPanel value={tab} index={1}>
                    <GroupKnowledgeSessionTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>)}
                  {resourcesDetails?.ExpertConsultations?.length > 0 && (
                  <TabPanel value={tab} index={2}>
                    <ExpertConsultationTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>)}
                  {resourcesDetails?.MarketOpportunities?.length > 0 && (
                  <TabPanel value={tab} index={3}>
                    <MarketOpportunitiesTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>)}
                  {resourcesDetails?.Compliances?.length > 0 && (
                    <TabPanel value={tab} index={4}>
                    <CompliancesTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>)}
                  {resourcesDetails?.LoanReadiness?.length > 0 && (
                  <TabPanel value={tab} index={5}>
                    <LoanReadinessTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>)}
                  {resourcesDetails?.Deigital?.length > 0 && (
                  <TabPanel value={tab} index={6}>
                    <DigitalEnablementTab
                      resourcesDetails={resourcesDetails}
                      addResourcesDetails={addResourcesDetails}
                    />
                  </TabPanel>)}
                </>
              ) : (
                <>
                {resourcesDetails?.KnowledgeSessions?.length > 0 && (
                  <PersonaDetailGroupKnowledgeSessionTabPage
                    value={newTab}
                    // index={0}
                    index={personaIndex++}
                    title="Group Knowledge Session Details"
                    userGroupKnowledgeSesssionPersonaDetails={userGroupKnowledgeSesssionPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueGroupKnowledgeInstanceId={uniqueGroupKnowledgeInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    groupKnowledgeAlreadyFilledPersonaInstanceId={groupKnowledgeAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                  />)}
                  {resourcesDetails?.ExpertConsultations?.length > 0 && (
                  <PersonaDetailExpertConsultationTabPage
                    value={newTab}
                    // index={1}
                    index={personaIndex++}
                    title="Expert Consultation Details"
                    userExptConsultationPersonaDetails={userExptConsultationPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueExpertConsultInstanceId={uniqueExpertConsultInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    expertConsiltAlreadyFilledPersonaInstanceId={expertConsiltAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                  />)}
                  {resourcesDetails?.MarketOpportunities?.length > 0 && (
                  <PersonaDetailMarketConnectTabPage
                    value={newTab}
                    // index={2}
                    index={personaIndex++}
                    title="Market Opportunities Details"
                    userMarketConnectPersonaDetails={userMarketConnectPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueMarketOppInstanceId={uniqueMarketOppInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    marketConnectAlreadyFilledPersonaInstanceId={marketConnectAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                  />)}
                  {resourcesDetails?.Compliances?.length > 0 && (
                  <PersonaDetailComplianceTabPage
                    value={newTab}
                    // index={3}
                    index={personaIndex++}
                    title="Compliances Details"
                    userCompliancePersonalDetails={userCompliancePersonalDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueComplianceInstanceId={uniqueComplianceInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    complianceAlreadyFilledPersonaInstanceId={complianceAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                  />)}
                  {resourcesDetails?.LoanReadiness?.length > 0 && (
                  <PersonaDetailBusinessLoanReadinessTabPage
                    value={newTab}
                    index={personaIndex++}
                    // index={4}
                    title="Loan Readiness Details"
                    userLoanReadinessPersonaDetails={userLoanReadinessPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueLoandReadinessInstanceId={uniqueLoandReadinessInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    loanReadinessAlreadyFilledPersonaInstanceId={loanReadinessAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                  />)}
                  {resourcesDetails?.Deigital?.length > 0 && (
                   <PersonaDetailDigitalEnablementTab
                    value={newTab}
                    index={personaIndex++}
                    // index={5}
                    title="Digital Enablement Details"
                    userDigitalEanblementPersonaDetails={userDigitalEanblementPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    handleSubmitDigitalPersonaDetails={handleSubmitDigitalPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueDigitalEnablementInstanceId={uniqueDigitalEnablementInstanceId}
                    digitalEnablementInstances={digitalEnablementInstances}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    digitalEnablementAlreadyFilledPersonaInstanceId={digitalEnablementAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                  />
                  )}
                </>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JpmcThreeSixtyDegreeModalProfilePage;
 